var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconEmail48Filled = function SvgIconEmail48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4 11.3H14.6a5.3 5.3 0 0 0-5.3 5.3v14.8a5.3 5.3 0 0 0 5.3 5.3h18.8a5.31 5.31 0 0 0 5.3-5.3V16.6a5.3 5.3 0 0 0-5.3-5.3Zm-7.55 13.36a2.9 2.9 0 0 1-3.71 0l-9.1-7.58 2.18-2.61L24 21.78l8.78-7.31 2.17 2.61-9.1 7.58Z",
    fill: "current"
  })));
};
export default SvgIconEmail48Filled;